export function getFeatureFlags(state) {
  return state.featureFlags
}
